export const PAGE_NOT_FOUND_TITLE =
  "Dieser Link ist nicht mehr gültig oder Sie besitzen noch nicht die entsprechenden Berechtigungen.";
export const PAGE_NOT_FOUND_DESCRIPTION = "";
export const PAGE_NOT_FOUND_BUTTON_TEXT = "Zur Fallübersicht";
